import { StaticRetryPlugin } from '@vk-tech-solar/module-federation-runtime-plugins';

const resolveHostBase = (url: string, hosts: string[]): string => {
  let match: string | undefined;
  for (const host of hosts) {
    const base = host.replace(/\/+$/, '');
    if (
      (url === base || url.startsWith(`${base}/`)) &&
      (match === undefined || match.length < base.length)
    ) {
      match = base;
    }
  }
  return match ?? new URL(url).origin;
};

const retryRuntimePlugin = () => {
  const STORAGE_KEY = 'last_static_fallback_success';

  return StaticRetryPlugin({
    // только хост, на котором реально сработал фолбэк: до первой ошибки url из манифеста
    // грузится как есть (относительные solar уже резолвит от staticHost)
    getLastSuccessHost: () => sessionStorage.getItem(STORAGE_KEY) || '',
    hosts: window.availableMFStaticHosts,
    onSuccess: url => {
      if (url) {
        sessionStorage.setItem(
          STORAGE_KEY,
          resolveHostBase(url, window.availableMFStaticHosts ?? []),
        );
      }
    },
  });
};

export default retryRuntimePlugin;
